module.exports = require("@material-ui/icons/ViewComfy");